export var OPEN_FORGOT_MODAL = 'OPEN_FORGOT_MODAL';
export var CLOSE_FORGOT_MODAL = 'CLOSE_FORGOT_MODAL';
export var CLOSE_SMS_RECOVER_MODAL = 'CLOSE_SMS_RECOVER_MODAL';
export var RECOVER_PASSWORD = 'RECOVER_PASSWORD';
export var SUCCESS_RECOVER_PASSWORD = 'SUCCESS_RECOVER_PASSWORD';
export var FAILURE_RECOVER_PASSWORD = 'FAILURE_RECOVER_PASSWORD';
export var RECOVER_UZ_PASSWORD = 'RECOVER_UZ_PASSWORD';
export var SUCCESS_RECOVER_UZ_PASSWORD = 'SUCCESS_RECOVER_UZ_PASSWORD';
export var FAILURE_RECOVER_UZ_PASSWORD = 'FAILURE_RECOVER_UZ_PASSWORD';
export var FETCH_SMS_RECOVERY_STATUS = 'FETCH_SMS_RECOVERY_STATUS';
export var SUCCESS_FETCH_SMS_RECOVERY_STATUS = 'SUCCESS_FETCH_SMS_RECOVERY_STATUS';
export var FAILURE_FETCH_SMS_RECOVERY_STATUS = 'FAILURE_FETCH_SMS_RECOVERY_STATUS';
export var FETCH_SMS_RECOVERY_CONFIRM = 'FETCH_SMS_RECOVERY_CONFIRM';
export var SUCCESS_FETCH_SMS_RECOVERY_CONFIRM = 'SUCCESS_FETCH_SMS_RECOVERY_CONFIRM';
export var FAILURE_FETCH_SMS_RECOVERY_CONFIRM = 'FAILURE_FETCH_SMS_RECOVERY_CONFIRM';
export var FETCH_UID_RECOVERY_CONFIRM = 'FETCH_UID_RECOVERY_CONFIRM';
export var SUCCESS_FETCH_UID_RECOVERY_CONFIRM = 'SUCCESS_FETCH_UID_RECOVERY_CONFIRM';
export var FAILURE_FETCH_UID_RECOVERY_CONFIRM = 'FAILURE_FETCH_UID_RECOVERY_CONFIRM';
export var FETCH_JOIN_STATUS = 'FETCH_JOIN_STATUS';
export var SUCCESS_FETCH_JOIN_STATUS = 'SUCCESS_FETCH_JOIN_STATUS';
export var FAILURE_FETCH_JOIN_STATUS = 'FAILURE_FETCH_JOIN_STATUS';



// WEBPACK FOOTER //
// ./src/actions/auth/Forgot.js